import Vue from 'vue'
import {Select,Button,Row,Col,Form,Input,AutoComplete,Icon,Tabs,Checkbox,Tree} from 'ant-design-vue'
import CommonFramework from "@/shared/components/commonFramework/index";
import poptitle from '@components/title/index.vue'
import treeWrap from './tree'
import { createNamespacedHelpers } from 'vuex'
import cookie from 'js-cookie'
import { util } from '@utils';

const {Item} = Form
const {TabPane} = Tabs
const {Option} = Select
const { mapState, mapActions } = createNamespacedHelpers('pages/roleManage/add')

export default {
    components:{
        Select,Option,Button,Icon,AutoComplete,Form,Item,Row,Col,Tabs,TabPane,Checkbox,Tree,
        CommonFramework,poptitle,treeWrap,Input
    },
    data() {
        return {
            dataSource: [],
            activeKey: 'busi',
            tabData: [
                //暂不修改后期可能动态增加多级循环tab页
                {
                    key:'busi',
                    name:'商家平台',
                    isCheck: false,
                    isIndet: false,
                    treeData:[]
                },
            ],
            type:'roleAdd',
            // buzzType:undefined,
            selectData:[],
            hasFeedback: {
                roleName: false,
                buzzType: true,
            },
            resIds:[],
            sessionResIds:[],
            validateState:'',
            help:'',
            isI1Disabled:true,
            isI2Disabled:true,
        }
    },
    async created() {

        // this.queryRoleData= {}
        this.form = this.$form.createForm(this,{
            onFieldsChange: (_, changedFields) => {
                this.hasFeedback[Object.keys(changedFields)[0]] = true
                if (Object.keys(changedFields)[0]=== 'roleName') {
                    this.isI1Disabled = !changedFields.roleName.value;
                }

                // console.log(changedFields)
            },
            // mapPropsToFields: () => {
            //     return {
            //         roleName: this.$form.createFormField({
            //             value: '',
            //         }),
            //         buzzType: this.$form.createFormField({
            //             value: undefined,
            //         }),
            //     };
            // },
        })
        this.type = this.$route.params.type;
        let id = this.$route.query.id;
        let buzzType =  cookie.get('buzzType');
        await this.getResList({params:{buzzType}})
        this.tabData[0].treeData = this.formataTreeData(this.resList)
        if (id) {
            //调接口
            await this.toModifyRole({params:{roleId:id}});
            this.isI1Disabled = !this.queryRoleData.roleName;
            const resIdsStr = this.queryRoleData.resIdsStr || []
            const childrenResIds = this.buildResIds(resIdsStr)
            this.$refs[this.activeKey][0].checkedKeys = childrenResIds
            this.$refs[this.activeKey][0].checkedKeysCopy = childrenResIds
            this.$nextTick(()=>{
                this.validateState = ''
                this.help = ''
            })
        }
    },
    mounted(){
        util.$tracker(157, '288919',10000);
        // this.tabData[1].treeData = this.resList

    },
    watch:{
    },
    methods: {
        ...mapActions(['addRole','modifyRole','getResList','toModifyRole']),
        buildResIds(ids) {
            const formatData = this.formataData
            const childrenResIds = ids.map(x => {
                const data = formatData.filter(y => (y.parentResId * 1) === (x * 1))
                if (data && data.length > 0) {
                    return null
                }
                return x
            })
            return childrenResIds
        },
        //新增修改保存
        save () {
            this.form.validateFields((err, values) => {
                let bool = this.isEmptyData();
                if (!err) {
                    if(!bool){return;}
                    let aid = cookie.get('id');
                    let buzzType = cookie.get('buzzType');
                    let roleId = this.$route.query.id;
                    let formatIds = this.resIds.filter(id=>{
                      return /^\d+$/.test(id)
                    })
                    let param = {
                        roleName:values.roleName,
                        aid,
                        buzzType,
                        roleId,
                        resIds:formatIds
                    }
                    if (this.type === 'roleAdd') {
                        this.addRole({param:JSON.stringify(param),callback:this.callback})
                    } else if (this.type === 'edit') {
                        this.modifyRole({param:JSON.stringify(param),callback:this.callback})
                    }
                }
            });
        },
        //data为需要修改的tree，这里主要是为antd design 里面select规范数据
        formataTreeData(data) {
            let item = [];
            data.forEach((list) => {
                let newData = {};
                newData.key= list.resId;
                // newData.value = list.id;
                newData.title = list.resName;
                newData.parentResId = list.parentResId;
                newData.children = list.subResList  ? this.formataTreeData(list.subResList) : [];    //如果还有子集，就再次调用自己
                item.push(newData);
            });
            return item;
        },
        callback() {
            this.$message.success('保存成功').then(()=>{
                this.$router.go(-1)
            });
        },
        searchData(treeData){
            let data = [];
            treeData.forEach(item => {
                let childList = [];
                if (item.children && item.children.length > 0) {
                    childList = this.searchData(item.children)
                }
                delete item.children;
                data = [...data,item,...childList]
            })
            return data
        },
        handleSearch (value) {
            if(!value){return};
            let searchData = [];
            this.formataData.forEach(item=>{
                if(item.title.includes(value)){
                    searchData=[
                        ...searchData,
                        {
                            value:item.key,
                            text:item.title
                        }
                    ]
                }
            })
            this.selectData =searchData;
        },
        handleChange (value) {
            this.$refs[this.activeKey][0].expandedKeys = [value]
            this.$refs[this.activeKey][0].autoExpandParent = true
            // this.form.validateFields(['buzzType']);
            // fetch(value, data => this.data = data);
        },
        isEmptyData () {

            // let busi = this.$refs.busi[0].checkedKeys
            let busi = this.$refs.busi[0].checkedKeysCopy
            let serve = []
          // console.log('busi',busi)
            // let serve = this.$refs.serve[0].checkedKeys
            // this.resIds = [...busi,...serve];
            this.resIds = [...busi,...serve];
            if (Array.isArray(this.resIds)&&this.resIds.length!==0) {
                this.isI2Disabled = false
                this.validateState = 'success'
                this.help = ''
                return true;
            } else {
                this.isI2Disabled = true
                this.validateState = 'error'
                this.help = '增加权限不可为空'
                return false;
            }

        },
        keyChange (state) {
            this.isEmptyData();
            // debugger
            this.tabData = this.tabData.map(item=>{
                if (item.key===this.activeKey) {
                    if (state==='all') {
                        item.isCheck = true;
                        item.isIndet = false;
                    } else if (state==='none') {
                        item.isCheck = false;
                        item.isIndet = false;
                    } else {
                        item.isCheck = false;
                        item.isIndet = true;
                    }
                }
                return item
            })
        },
        keysRecursion(list) {
            let data = [];
            list.map(item => {
                let childList = [];
                if (item.children && item.children.length > 0) {
                    childList = this.keysRecursion(item.children)
                }
                data = [...data,item.key,...childList]
            })
            return data
        },
        onChange(e) {
            const bool = e.target.checked;
            if (bool) {
                let dataItem = this.tabData.find(item=>item.key===this.activeKey)
                this.$refs[this.activeKey][0].checkedKeys =this.keysRecursion(dataItem.treeData)
                this.$refs[this.activeKey][0].checkedKeysCopy =this.keysRecursion(dataItem.treeData)
            }
            else {
                this.$refs[this.activeKey][0].checkedKeys = [];
                this.$refs[this.activeKey][0].checkedKeysCopy = [];
            }
        },
        // handleSearch(value) {
        //     this.dataSource = !value ? [] : [
        //         value,
        //         value + value,
        //         value + value + value,
        //     ]
        // }
    },
    computed:{
        ...mapState(['resList','queryRoleData']),
        formataData(){
            return this.searchData(this.formataTreeData(this.resList))
        },
        isDisabled(){
            return this.isI1Disabled || this.isI2Disabled
        }
    }
  }
